import { Grid2, IconButton } from "@mui/material";
import CustomTable from "./CustomTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import { useClientContext } from "../context/ClientContext";
import { formatCurrency } from "../utils/helper";
import { clientGroups } from "../assets/clientData";
import { thirdPartyFund } from "../assets/thirdPartyFund";

const ThirdPartyFundTable = ({ setLevel }) => {
  const [tableData, setTableData] = useState([]);
  const { clientName, clientGroup } = useClientContext();

  const columns = [
    {
      name: "Account Number",
      id: "id_number",
    },
    {
      name: "Product Name",
      id: "product_name", 
    },
    {
      name: "Balance",
      id: "balance",
      element: (row) => `${formatCurrency(row.balance)}`,
    },
    {
      name: "Average Balance (Last 6 months)",
      id: "balance_2quarter",
      element: (row) => `${formatCurrency(row.balance_2quarter)}`,
    },
    {
      name: "Account Status",
      id: "account_status"
    },
    {
      name: "Opening Date", 
      id: "acct_open_date"
    },
    {
      name: "Maturity Date",
      id: "maturity_date"
    }
  ];

  useEffect(() => {
    // Filter data based on selected client and group
    if (clientName && clientGroup) {
      const filteredData = thirdPartyFund.filter(
        (data) =>
          data.company_name === clientName &&
          data.group_company === clientGroups.find((group) => group.group_name === clientGroup)?.label
      );


        //console.log('filteredData', filteredData);  
        setTableData(filteredData);
      
    }
  }, [clientName, clientGroup]);

  const handleTableView = () => {
    setLevel('L1');
  };

  return (
    <div className="my-4">
      <Grid2 display={"grid"} rowGap={2}>
        <div className='flex flex-start items-center h-[1rem] mx-1'>
          <IconButton aria-label="back" onClick={handleTableView}>
            <ArrowBackIcon sx={{ fontSize: 16 }}/>
          </IconButton>
        </div>
        <div className="flex font-bold text-xs charts-data-container mx-4">
          Third Party Fund(DPK) Accounts
        </div>
        <div className="mx-4">
          <CustomTable
            columns={columns}
            data={tableData}
            hidePagination
          />
        </div>
      </Grid2>
    </div>
  );
};

export default ThirdPartyFundTable;
